<router-outlet></router-outlet>

<router-outlet name="dialog"></router-outlet>